import React, { useState, useEffect, useRef, useCallback } from 'react';

import mahakalmandir from '../assets/Mahakaltemple.jpg';
import mahakalcorridor from '../assets/corridor.jpg';
import chintaman from '../assets/chintaman.jpg'; // replace with your preferred image
import river from '../assets/river.jpg';
import mangalnath from '../assets/mangalnath.jpg';
import kalbhairav from '../assets/kalbhairav.jpg';

const slides = [
  {
    img: mahakalmandir,
    title: 'Mahakaleshwar Mandir',
    subtitle: 'One of the 12 Jyotirlingas',
    dist: '1.5 km away',
    desc: 'The sacred Mahakaleshwar Jyotirlinga — one of the holiest Shiva temples in India — stands just 1.5 km from our doorstep, making Shree Maya Comfort Inn the ideal base for pilgrims.',
  },
  {
    img: mahakalcorridor,
    title: 'Mahakal Corridor',
    subtitle: 'Mahakal Lok — The Grand Promenade',
    dist: '1.5 km away',
    desc: 'The magnificent Mahakal Lok corridor stretches nearly 900 metres and is adorned with 108 life-size sculptures depicting the stories of Lord Shiva. A breathtaking experience day and night.',
  },
  {
    img: chintaman,
    title: 'Chintaman Ganesh Mandir',
    subtitle: 'Dedicated to Lord Ganesh',
    dist: '6 km away',
    desc: 'Devotees revere it as the ultimate spot for finding peace and removing worldly worries.',
  },
  {
    img: river,
    title: 'Sacred Ghats & Kshipra',
    subtitle: 'The holy Kshipra river',
    dist: 'Nearby',
    desc: 'The sacred banks of the Kshipra river host ancient rituals and evening aarti ceremonies that have continued for centuries.',
  },
  {
    img: kalbhairav,
    title: 'The Kaal Bhairav Mandir',
    subtitle: 'Lord of the Universe',
    dist: '8 km',
    desc: 'The Kotwal of the Universe: Where Devotion Meets Divine Protection.',
  },
  {
    img: mangalnath,
    title: 'Mangalnath Mandir',
    subtitle: '',
    dist: 'Nearby',
    desc: 'Where the Tropic of Cancer Meets Divine Energy,The Ultimate Haven for Mangal Dosh Nivaran.',
  },
];

export default function NearbyCarousel() {
  const [active, setActive] = useState(0);
  const [fading, setFading] = useState(false);
  const intervalRef = useRef(null);
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const goTo = useCallback((idx) => {
    setFading(true);
    setTimeout(() => {
      setActive(idx);
      setFading(false);
    }, 320);
  }, []);

  const next = useCallback(() => goTo((active + 1) % slides.length), [active, goTo]);
  const prev = useCallback(() => goTo((active - 1 + slides.length) % slides.length), [active, goTo]);

  useEffect(() => {
    intervalRef.current = setInterval(next, 5500);
    return () => clearInterval(intervalRef.current);
  }, [next]);

  const pause = () => clearInterval(intervalRef.current);
  const resume = () => { intervalRef.current = setInterval(next, 5500); };

  const s = slides[active];

  return (
    <>
      <style>{`
        @keyframes carouselFade { from{opacity:0;transform:scale(1.03);} to{opacity:1;transform:scale(1);} }
        .car-img { animation: carouselFade .65s ease forwards; }
        .car-arrow { background: rgba(242,232,217,0.12); border: 1px solid rgba(242,232,217,0.3);
          color: #F2E8D9; width: 48px; height: 48px; display:flex; align-items:center;
          justify-content:center; cursor:pointer; font-size:1.1rem; transition: all .3s;
          flex-shrink:0; }
        .car-arrow:hover { background: #C9A84C; border-color:#C9A84C; color:#0F1D48; }
        .car-dot { width:8px; height:8px; border-radius:50%; cursor:pointer;
          transition: all .35s ease; border: 1px solid rgba(201,168,76,0.6); }
        .car-dot.active { background: #C9A84C; border-color:#C9A84C; transform: scale(1.3); }
        .car-dot:not(.active) { background: transparent; }
        .car-dot:not(.active):hover { background: rgba(201,168,76,0.4); }
        @media(max-width:860px){
          .car-layout { grid-template-columns:1fr !important; }
          .car-img-wrap { aspect-ratio:16/9 !important; min-height:0 !important; }
        }
      `}</style>

      <section id="nearby" style={{ padding:'7rem 3rem', background:'#0F1D48' }} ref={ref}>
        <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
          {/* Header */}
          <div style={{
            textAlign:'center', marginBottom:'3.5rem',
            opacity: visible ? 1 : 0, transform: visible ? 'none' : 'translateY(24px)',
            transition: 'opacity .9s ease, transform .9s ease',
          }}>
            <div style={{ display:'flex', alignItems:'center', gap:'.8rem', justifyContent:'center', marginBottom:'1rem' }}>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
              <div style={{ width:'5px', height:'5px', background:'#C9A84C', transform:'rotate(45deg)' }}/>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
            </div>
            <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.58rem', letterSpacing:'5px',
              textTransform:'uppercase', color:'#C9A84C', marginBottom:'.7rem', fontWeight:300 }}>
              Just 1.5 km Away
            </p>
            <h2 style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.9rem,4vw,2.9rem)',
              fontWeight:500, color:'#F2E8D9', marginBottom:'.3rem' }}>
              Mahakal Mandir
            </h2>
            <h3 style={{ fontFamily:"'Cormorant',serif", fontSize:'clamp(1.2rem,2.5vw,1.9rem)',
              fontStyle:'italic', fontWeight:400, color:'#C9A84C' }}>
              &amp; The Grand Mahakal Corridor
            </h3>
          </div>

          {/* Carousel */}
          <div
            className="car-layout"
            style={{
              display:'grid', gridTemplateColumns:'1.15fr 1fr',
              border:'1px solid rgba(201,168,76,0.2)',
              opacity: visible ? 1 : 0, transform: visible ? 'none' : 'translateY(28px)',
              transition: 'opacity 1s ease .2s, transform 1s ease .2s',
            }}
            onMouseEnter={pause} onMouseLeave={resume}
          >
            {/* Image panel */}
            <div className="car-img-wrap" style={{
              position:'relative', overflow:'hidden', minHeight:'480px',
            }}>
              {!fading && (
                <img
                  key={active}
                  className="car-img"
                  src={s.img}
                  alt={s.title}
                  style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }}
                />
              )}
              {fading && (
                <div style={{ width:'100%', height:'100%', background:'#0F1D48' }}/>
              )}
              {/* Dark gradient */}
              <div style={{
                position:'absolute', inset:0,
                background:'linear-gradient(to top, rgba(15,29,72,0.7) 0%, transparent 50%)',
              }}/>
              {/* Slide counter */}
              <div style={{
                position:'absolute', top:'1.2rem', right:'1.2rem',
                fontFamily:"'Jost',sans-serif", fontSize:'.6rem', letterSpacing:'3px',
                color:'rgba(242,232,217,.7)', background:'rgba(15,29,72,0.6)',
                padding:'.35rem .8rem', backdropFilter:'blur(8px)',
              }}>
                {String(active + 1).padStart(2,'0')} / {String(slides.length).padStart(2,'0')}
              </div>
              {/* Dist badge */}
              <div style={{
                position:'absolute', bottom:'1.2rem', left:'1.2rem',
                background:'#C9A84C', color:'#0F1D48',
                fontFamily:"'Jost',sans-serif", fontSize:'.52rem', letterSpacing:'3px',
                textTransform:'uppercase', padding:'.3rem .9rem', fontWeight:500,
              }}>
                📍 {s.dist}
              </div>
            </div>

            {/* Info panel */}
            <div style={{ padding:'3rem 2.5rem', display:'flex', flexDirection:'column', justifyContent:'space-between', background:'rgba(27,47,110,0.4)' }}>
              <div>
                <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.55rem', letterSpacing:'4px',
                  textTransform:'uppercase', color:'rgba(201,168,76,0.7)', marginBottom:'.6rem', fontWeight:300 }}>
                  {s.subtitle}
                </p>
                <h3 style={{
                  fontFamily:"'Cinzel',serif", fontSize:'clamp(1.4rem,3vw,2rem)',
                  fontWeight:500, color:'#F2E8D9', lineHeight:1.15, marginBottom:'1.3rem',
                  opacity: fading ? 0 : 1, transition:'opacity .32s',
                }}>
                  {s.title}
                </h3>
                <p style={{
                  fontFamily:"'EB Garamond',serif", fontSize:'1.05rem', lineHeight:1.9,
                  color:'rgba(242,232,217,0.65)', marginBottom:'2rem',
                  opacity: fading ? 0 : 1, transition:'opacity .32s .05s',
                }}>
                  {s.desc}
                </p>
              </div>

              {/* Controls */}
              <div>
                {/* Dots */}
                <div style={{ display:'flex', gap:'.7rem', marginBottom:'1.8rem' }}>
                  {slides.map((_, i) => (
                    <div
                      key={i}
                      className={`car-dot${i === active ? ' active' : ''}`}
                      onClick={() => goTo(i)}
                    />
                  ))}
                </div>
                {/* Arrows */}
                <div style={{ display:'flex', gap:'0.8rem' }}>
                  <button className="car-arrow" onClick={prev} aria-label="Previous">←</button>
                  <button className="car-arrow" onClick={next} aria-label="Next">→</button>
                  <div style={{ flex:1, display:'flex', alignItems:'center', paddingLeft:'1rem' }}>
                    <div style={{
                      height:'1px', background:'rgba(201,168,76,0.25)', flex:1, position:'relative', overflow:'hidden',
                    }}>
                      <div style={{
                        position:'absolute', top:0, left:0, height:'100%',
                        background:'#C9A84C',
                        width:`${((active + 1) / slides.length) * 100}%`,
                        transition:'width .5s ease',
                      }}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Thumbnail strip */}
          <div style={{
            display:'flex', gap:'4px', marginTop:'4px',
            opacity: visible ? 1 : 0, transition:'opacity 1.1s ease .4s',
          }}>
            {slides.map((sl, i) => (
              <div
                key={i}
                onClick={() => goTo(i)}
                style={{
                  flex:1, aspectRatio:'16/5', overflow:'hidden', cursor:'pointer',
                  opacity: i === active ? 1 : 0.45,
                  transition:'opacity .35s ease',
                  outline: i === active ? '2px solid #C9A84C' : 'none',
                  outlineOffset:'-2px',
                }}
              >
                <img src={sl.img} alt={sl.title}
                  style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }}/>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
